<vt-visit-back-menu-item
  (menuItemClick)="handleBackMenuItemClick()"
></vt-visit-back-menu-item>

<ng-content></ng-content>
